module.exports = __webpack_public_path__ + "static/media/Logo.f9e73810.svg";